module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl1-50.fb26bfb4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/attack-bomber-squadrons-lvl1-50.png
// module id = 3506
// module chunks = 11